import ready from 'document-ready';
import personalize from '../modules/personalization';
import preserveUTMs from '../modules/utm';

export default () => {
  const aeCanPersonalize = window.aeCanPersonalize;
  const aeCanPreserveUTMs = window.aeCanPreserveUTMs;

  if (!aeCanPersonalize && !aeCanPreserveUTMs) {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (aeCanPersonalize) {
        personalize(mutation);
      }

      if (aeCanPreserveUTMs) {
        preserveUTMs(mutation);
      }
    }
  });

  observer.observe(document, {
    attributes: false,
    childList: true,
    subtree: true
  });

  ready(() => observer.disconnect());
};
